<div class="max-w-screen-xl p-6 mx-auto bg-white shadow-md rounded-xl">
  <h2 class="mb-6 text-2xl font-medium text-gray-800">Demande de Licence</h2>

  <!-- Formulaire de demande -->
  <form (ngSubmit)="submitDemande()" class="grid grid-cols-3 col-span-3 gap-6">

    <!-- Type de demande -->
    <div class="col-span-3 p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
      <h3 class="mb-4 text-lg font-semibold text-gray-800">Type de demande</h3>
      <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <label class="relative flex cursor-pointer">
          <input type="radio" name="typeDemande" value="NOUVELLE" [(ngModel)]="demande.typeDemande" class="sr-only"
            required (change)="onTypeDemandeChange()">
          <div class="flex-1 p-4 transition-all border-2 rounded-lg"
            [class.border-blue-500]="demande.typeDemande === 'NOUVELLE'"
            [class.bg-blue-50]="demande.typeDemande === 'NOUVELLE'"
            [class.border-gray-300]="demande.typeDemande !== 'NOUVELLE'"
            [class.bg-white]="demande.typeDemande !== 'NOUVELLE'">
            <div class="flex items-center">
              <div class="flex items-center justify-center w-6 h-6 mr-3 border-2 rounded-full"
                [class.border-blue-500]="demande.typeDemande === 'NOUVELLE'"
                [class.border-gray-300]="demande.typeDemande !== 'NOUVELLE'">
                <div *ngIf="demande.typeDemande === 'NOUVELLE'" class="w-3 h-3 bg-blue-500 rounded-full"></div>
              </div>
              <div>
                <h4 class="font-medium text-gray-800">Nouvelle Licence</h4>
                <p class="mt-1 text-sm text-gray-600">Demande d'une nouvelle licence</p>
              </div>
            </div>
          </div>
        </label>

        <label class="relative flex cursor-pointer">
          <input type="radio" name="typeDemande" value="RENOUVELLEMENT" [(ngModel)]="demande.typeDemande"
            class="sr-only" required (change)="onTypeDemandeChange()">
          <div class="flex-1 p-4 transition-all border-2 rounded-lg"
            [class.border-blue-500]="demande.typeDemande === 'RENOUVELLEMENT'"
            [class.bg-blue-50]="demande.typeDemande === 'RENOUVELLEMENT'"
            [class.border-gray-300]="demande.typeDemande !== 'RENOUVELLEMENT'"
            [class.bg-white]="demande.typeDemande !== 'RENOUVELLEMENT'">
            <div class="flex items-center">
              <div class="flex items-center justify-center w-6 h-6 mr-3 border-2 rounded-full"
                [class.border-blue-500]="demande.typeDemande === 'RENOUVELLEMENT'"
                [class.border-gray-300]="demande.typeDemande !== 'RENOUVELLEMENT'">
                <div *ngIf="demande.typeDemande === 'RENOUVELLEMENT'" class="w-3 h-3 bg-blue-500 rounded-full"></div>
              </div>
              <div>
                <h4 class="font-medium text-gray-800">Renouvellement</h4>
                <p class="mt-1 text-sm text-gray-600">Renouvellement d'une licence existante</p>
              </div>
            </div>
          </div>
        </label>
      </div>

    </div>

    <!-- Sélection de licence (uniquement pour le renouvellement) -->
    <div *ngIf="isRenouvellement()" class="col-span-3 p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
      <h3 class="mb-4 text-lg font-semibold text-gray-800">Licence à renouveler</h3>
      <div class="grid grid-cols-2 gap-6">
        <div>
          <div class="flex items-center">
            <label class="block mb-2 text-sm font-medium text-gray-800">
              Sélectionnez votre licence
            </label>
            <span class="ml-1 text-red-500">*</span>
          </div>
          <select name="licence" [(ngModel)]="demande.licenceId" required
            class="bg-gray-50 border border-gray-800 text-gray-800 text-sm rounded-lg focus:ring-gray-500 focus:border-gray-500 block w-full p-2.5"
            (change)="onLicenceChange()">
            <option value="">Sélectionnez une licence</option>
            <option *ngFor="let licence of licencesUtilisateur" [value]="licence.id">
              {{ licence.numerolicence }} - {{ licence.partenaire?.nom }}
              ({{ licence.isPro ? 'PRO' : 'FREE' }})
            </option>
          </select>

        </div>
      </div>

      <!-- Informations de la licence sélectionnée -->
      <div *ngIf="licenceSelectionnee" class="p-4 mt-4 border border-gray-200 rounded-lg bg-gray-50">
        <h4 class="mb-3 font-medium text-gray-800">Informations de la licence</h4>
        <div class="grid grid-cols-2 gap-4 text-sm">
          <div>
            <span class="text-gray-600">Numéro:</span>
            <p class="font-medium text-gray-800">{{ licenceSelectionnee.numerolicence }}</p>
          </div>
          <div>
            <span class="text-gray-600">Partenaire:</span>
            <p class="font-medium text-gray-800">{{ licenceSelectionnee.partenaire?.nom }}</p>
          </div>
          <div>
            <span class="text-gray-600">Type:</span>
            <p class="font-medium text-gray-800">{{ licenceSelectionnee.isPro ? 'Professionnelle' : 'Gratuite' }}</p>
          </div>
          <div>
            <span class="text-gray-600">Statut:</span>
            <span [ngClass]="{
              'bg-green-100 text-green-800': licenceSelectionnee.status === 'ACTIVE',
              'bg-red-100 text-red-800': licenceSelectionnee.status === 'EXPIRED',
              'bg-yellow-100 text-yellow-800': licenceSelectionnee.status === 'SUSPENDED'
            }" class="text-xs font-medium px-2.5 py-0.5 rounded">
              {{ getStatusText(licenceSelectionnee.status) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Informations pour nouvelle licence -->
    <div *ngIf="isNouvelleLicence()" class="col-span-3 p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
      <h3 class="mb-4 text-lg font-semibold text-gray-800">Informations pour la nouvelle licence</h3>
      <div class="grid grid-cols-3 gap-6">




        <!-- Type de licence souhaitée -->
        <div class="col-span-3">
          <div class="flex items-center mb-3">
            <label class="block text-sm font-medium text-gray-800">
              Type de licence souhaitée
            </label>
            <span class="ml-1 text-red-500">*</span>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <label class="relative flex cursor-pointer">
              <input type="radio" name="typeLicence" value="FREE" [(ngModel)]="demande.typeLicence" required
                class="sr-only">
              <div class="flex-1 p-4 transition-all border-2 rounded-lg"
                [class.border-green-500]="demande.typeLicence === 'FREE'"
                [class.bg-green-50]="demande.typeLicence === 'FREE'"
                [class.border-gray-300]="demande.typeLicence !== 'FREE'"
                [class.bg-white]="demande.typeLicence !== 'FREE'">
                <div class="flex items-center justify-between">
                  <div>
                    <h4 class="font-medium text-gray-800">Licence Gratuite</h4>
                    <p class="mt-1 text-sm text-gray-600">Fonctionnalités de base</p>
                  </div>
                  <div class="text-2xl font-bold text-green-600">Gratuit</div>
                </div>
                <ul class="mt-3 space-y-1 text-sm text-gray-600">
                  <li>• Inspections limitées</li>
                  <li>• Rapports basiques</li>
                  <li>• Support standard</li>
                </ul>
              </div>
            </label>

            <label class="relative flex cursor-pointer">
              <input type="radio" name="typeLicence" value="PRO" [(ngModel)]="demande.typeLicence" required
                class="sr-only">
              <div class="flex-1 p-4 transition-all border-2 rounded-lg"
                [class.border-blue-500]="demande.typeLicence === 'PRO'"
                [class.bg-blue-50]="demande.typeLicence === 'PRO'"
                [class.border-gray-300]="demande.typeLicence !== 'PRO'"
                [class.bg-white]="demande.typeLicence !== 'PRO'">
                <div class="flex items-center justify-between">
                  <div>
                    <h4 class="font-medium text-gray-800">Licence Pro</h4>
                    <p class="mt-1 text-sm text-gray-600">Fonctionnalités complètes</p>
                  </div>
                  <div class="text-2xl font-bold text-blue-600">Payant</div>
                </div>
                <ul class="mt-3 space-y-1 text-sm text-gray-600">
                  <li>• Inspections illimitées</li>
                  <li>• Rapports avancés</li>
                  <li>• Support prioritaire</li>
                  <li>• Analytics détaillés</li>
                </ul>
              </div>
            </label>
          </div>

        </div>
      </div>
    </div>

    <!-- Commentaire -->
    <div class="col-span-3 p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
      <h3 class="mb-4 text-lg font-semibold text-gray-800">Commentaire</h3>
      <div>
        <label class="block mb-2 text-sm font-medium text-gray-800">
          Informations supplémentaires
        </label>
        <textarea name="commentaire" [(ngModel)]="demande.commentaire" rows="4"
          placeholder="Décrivez votre besoin, la raison de votre demande, ou toute information utile..."
          class="bg-gray-50 border border-gray-800 text-gray-800 text-sm rounded-lg focus:ring-gray-500 focus:border-gray-500 block w-full p-2.5 resize-none"></textarea>
        <p class="mt-1 text-xs text-gray-500">
          Ce commentaire aidera notre équipe à traiter votre demande plus efficacement.
        </p>
      </div>
    </div>

    <!-- Informations de l'utilisateur connecté -->
    <div class="col-span-3 p-6 border border-gray-200 rounded-lg bg-gray-50">
      <h3 class="mb-4 text-lg font-semibold text-gray-800">Vos informations</h3>
      <div class="grid grid-cols-3 gap-4">
        <div>
          <span class="text-sm text-gray-600">Nom complet:</span>
          <p class="font-medium text-gray-800">{{ utilisateur?.nom }} {{ utilisateur?.prenom }}</p>
        </div>
        <div>
          <span class="text-sm text-gray-600">Email:</span>
          <p class="font-medium text-gray-800">{{ utilisateur?.email }}</p>
        </div>
        <div>
          <span class="text-sm text-gray-600">Date de soumission:</span>
          <p class="font-medium text-gray-800">{{ today | date:'dd/MM/yyyy' }}</p>
        </div>
      </div>
    </div>

    <!-- Boutons de soumission -->
    <div class="flex justify-end col-start-3">
      <button type="button" (click)="cancel()"
        class="mt-4 flex items-center gap-2 text-gray-700 bg-gray-200 hover:bg-gray-300 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-6 py-2.5 text-center">
        Annuler
      </button>
      <button type="submit" [disabled]="isSubmitting"
        class="mt-4 ml-4 flex items-center gap-2 text-white bg-gray-600 hover:bg-gray-700 focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-6 py-2.5 text-center disabled:opacity-50 disabled:cursor-not-allowed">
        <svg *ngIf="isSubmitting" class="w-4 h-4 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 2v4m0 12v4m8-10h-4M6 12H2" />
        </svg>
        {{ isSubmitting ? 'Soumission...' : 'Soumettre la demande' }}
      </button>
    </div>
  </form>
</div>

<!-- Modal de confirmation -->
<div *ngIf="showConfirmationModal" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
  <div class="w-11/12 max-w-md p-6 bg-white border border-gray-200 rounded-lg shadow-lg">
    <div class="text-center">
      <div class="flex items-center justify-center w-12 h-12 mx-auto bg-green-100 rounded-full">
        <svg class="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h3 class="mt-4 text-xl font-semibold text-gray-800">Demande soumise !</h3>
      <p class="mt-2 text-gray-600">
        Votre demande de {{ isRenouvellement() ? 'renouvellement' : 'nouvelle licence' }} a été soumise avec succès.
        Notre équipe la traitera dans les plus brefs délais.
      </p>
      <div class="mt-6">
        <button (click)="closeConfirmationModal()"
          class="px-6 py-2 text-white bg-gray-600 border border-gray-700 rounded-lg hover:bg-gray-700">
          Fermer
        </button>
      </div>
    </div>
  </div>
</div>